<script>
import MigrationForm from './MigrationForm.vue'

export default {
  components: {
    MigrationForm
  },
  data: vm => {
    return {
      userData: {
        email: null,
        salutation: null,
        firstName: null,
        lastName: null,
        address: null,
        addressAddition: null,
        city: null,
        zipCode: null,
        phoneNumber: null,
        taxId: null
      },
      unpack: {
        loading: true,
        failed: false
      },
      dialog: {
        color: 'primary'
      },
      saving: false,
      registrationState: {
        success: 'success',
        userExists: 'userExists',
        error: 'error'
      },
      registration: {
        state: null,
        success: {
          header: this.$t('component.profile.accountManagement.account.created'),
          content: this.$t('component.profile.accountManagement.created.content'),
          color: 'success',
          button: {
            color: 'success',
            text: this.$t('button.home'),
            action: () =>
              vm.$router.push({ name: 'homepage', params: { locale: 'de' } })
          }
        },
        userExists: {
          header: this.$t('component.profile.accountManagement.account.exists'),
          content: this.$t('component.profile.accountManagement.account.exists.content'),
          color: 'orange',
          button: {
            color: 'primary',
            text: this.$t('button.home'),
            action: () =>
              vm.$router.push({ name: 'homepage', params: { locale: 'de' } })
          }
        },
        error: {
          header: this.$t('global.error.header'),
          content: this.$t('global..error.content'),
          color: 'error',
          button: {
            color: 'primary',
            text: this.$t('button.back'),
            action: () => (vm.registration.state = null)
          }
        }
      }
    }
  },
  created() {
    try {
      const {
        email,
        salutation,
        firstName,
        lastName,
        address,
        addressAddition, // optional
        city,
        zipCode,
        phoneNumber, // optional
        taxId // optional
      } = this.$route.query
      this.userData.userName = email
      this.userData.email = email
      this.userData.salutation = salutation ? parseInt(salutation) : null
      this.userData.firstName = firstName
      this.userData.lastName = lastName
      this.userData.address = address
      this.userData.addressAddition = addressAddition
      this.userData.city = city
      this.userData.zipCode = zipCode
      this.userData.phoneNumber = phoneNumber
      this.userData.taxId = taxId || ''
      this.userData.country = this.$t('global..error.content')

      this.userData.confirmationURL = `${window.config.VUE_APP_BASE_URL}/registrationconfirmation`
    } catch (error) {
      this.unpack.failed = true
      this.dialog.color = 'error'
    } finally {
      this.unpack.loading = false
    }
  },
  methods: {
    handleRegister() {
      this.$refs.migrationForm.$v.$touch()
      this.userData.userName = this.userData.email
      if (!this.$refs.migrationForm.$v.$invalid) {
        this.saving = true
        return this.$userService
          .registerIvoris(this.userData)
          .then(() => {
            this.registration.state = this.registrationState.success
          })
          .catch(e => {
            if (e.response.status === 409)
              this.registration.state = this.registrationState.userExists
            else this.registration.state = this.registrationState.error
          })
          .finally(() => {
            this.saving = false
          })
      }
    }
  }
}
</script>
<template>
  <v-dialog
    :value="true"
    outlined
    :max-width="1024"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card v-if="registration.state">
      <DialogBaseColoredTitle :color="registration[registration.state].color">{{
          registration[registration.state].header
        }}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText>
        <v-row class="justify-center text-center">
          <v-col>
            <span v-html="registration[registration.state].content" />
          </v-col>
        </v-row>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn
          class="text-center px-8"
          :color="registration[registration.state].button.color"
          @click.stop="registration[registration.state].button.action()"
        >{{ registration[registration.state].button.text }}</v-btn>
      </DialogBaseActions>
    </v-card>
    <v-card v-if="!registration.state">
      <DialogBaseColoredTitle :color="dialog.color">
        {{$t('component.profile.accountManagement.welcome')}}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText v-if="unpack.loading">
        <v-row class="justify-center text-center">
          <v-col>
            <v-progress-circular color="primary" indeterminate />
            {{$t('global.please.wait')}}
          </v-col>
        </v-row>
      </DialogBaseText>
      <DialogBaseText v-else-if="unpack.failed">
        <v-row class="justify-center text-center">
          <v-col>{{$t('global.error')}} </v-col>
        </v-row>
      </DialogBaseText>
      <DialogBaseText v-else class="text-center">
        <v-row>
          <v-col>
            <span>{{$t('component.profile.accountManagement.billing.data')}}</span>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <MigrationForm ref="migrationForm" v-model="userData" />
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions v-if="!unpack.loading && !unpack.failed">
        <v-btn
          class="text-center px-8"
          color="primary"
          @click.stop="handleRegister">
          {{$t('button.register')}}</v-btn>
      </DialogBaseActions>
      <DialogBaseActions v-if="unpack.failed">
        <v-btn
          class="text-center px-8"
          color="primary"
          :loading="saving"
          @click.stop="
            $router.push({ name: 'homepage', params: { locale: 'de' } })"
        >{{$t('button.home')}}</v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">
.icon_border_round {
  border-radius: 50px;
  border: 2px solid;
  padding: 10px;
  width: 100px;
  height: 100px;
}
</style>
